export const SuccessModalStatusIcon = () => {
  return (
    <svg
      width="81"
      height="80"
      viewBox="0 0 81 80"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="check_circle_FILL0_wght400_GRAD0_opsz24 (1) 1">
        <path
          id="Vector"
          d="M35.8334 55.3332L59.3334 31.8332L54.6667 27.1665L35.8334 45.9998L26.3334 36.4998L21.6667 41.1665L35.8334 55.3332ZM40.5001 73.3332C35.889 73.3332 31.5556 72.4582 27.5001 70.7082C23.4445 68.9582 19.9167 66.5832 16.9167 63.5832C13.9167 60.5832 11.5417 57.0554 9.79175 52.9998C8.04175 48.9443 7.16675 44.6109 7.16675 39.9998C7.16675 35.3887 8.04175 31.0554 9.79175 26.9998C11.5417 22.9443 13.9167 19.4165 16.9167 16.4165C19.9167 13.4165 23.4445 11.0415 27.5001 9.2915C31.5556 7.5415 35.889 6.6665 40.5001 6.6665C45.1112 6.6665 49.4445 7.5415 53.5001 9.2915C57.5556 11.0415 61.0834 13.4165 64.0834 16.4165C67.0834 19.4165 69.4584 22.9443 71.2084 26.9998C72.9584 31.0554 73.8334 35.3887 73.8334 39.9998C73.8334 44.6109 72.9584 48.9443 71.2084 52.9998C69.4584 57.0554 67.0834 60.5832 64.0834 63.5832C61.0834 66.5832 57.5556 68.9582 53.5001 70.7082C49.4445 72.4582 45.1112 73.3332 40.5001 73.3332ZM40.5001 66.6665C47.9445 66.6665 54.2501 64.0832 59.4167 58.9165C64.5834 53.7498 67.1667 47.4443 67.1667 39.9998C67.1667 32.5554 64.5834 26.2498 59.4167 21.0832C54.2501 15.9165 47.9445 13.3332 40.5001 13.3332C33.0556 13.3332 26.7501 15.9165 21.5834 21.0832C16.4167 26.2498 13.8334 32.5554 13.8334 39.9998C13.8334 47.4443 16.4167 53.7498 21.5834 58.9165C26.7501 64.0832 33.0556 66.6665 40.5001 66.6665Z"
          fill="url(#paint0_linear_230_393)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_230_393"
          x1="7.16675"
          y1="6.6665"
          x2="77.4571"
          y2="10.7355"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4CAF50" />
          <stop offset="1" stopColor="#2E7D32" />
        </linearGradient>
      </defs>
    </svg>
  );
};
